import { EntityService } from '../../../service/EntityService';

export class TenantClientService extends EntityService {

  static entity = 'api/app/tenant-client';

  static searchTaxCode(taxCode: any): Promise<any> {
    return this.axios.get(`${this.entity}/serch-tax-code?taxCode=${taxCode}`).then(res => res.data);
  }

  static searchIdentityCar(identityCard: any): Promise<any> {
    return this.axios.get(`${this.entity}/serch-identity-card?identityCode=${identityCard}`).then(res => res.data);
  }

}
